import { UnsupportedPinSettings } from '@lessonup/pins-shared';
import { TFunction } from 'i18next';

export function mapOriginalTypeToTranslation(
  originalType: UnsupportedPinSettings['originalType'],
  t: TFunction
): string {
  switch (originalType) {
    case 'video':
      return t('originalType.video');
    case 'map':
      return t('originalType.map');
    case 'slide':
      return t('originalType.slide');
    case 'question':
      return t('originalType.question');
    case 'openQuestion':
      return t('originalType.openQuestion');
    case 'wordweb':
      return t('originalType.wordweb');
    case 'poll':
      return t('originalType.poll');
    case 'dragQuestion':
      return t('originalType.dragQuestion');
    case 'link':
      return t('originalType.link');
  }
}
